// HistoryOfConnaughtLodgeLodge.js
import React from "react";
import "./HistoryOfConnaught.css"; // (Optional) Dedicated styling

function HistoryOfConnaughtLodge() {
    return (
        <div className="history-connaught-container">
            <h2>Brief History of Connaught Lodge No. 361 I.C.</h2>

            <p>
                Connaught Lodge No. 361 I.C. was formed in Pretoria in 1903, during the
                early years of organised Irish Freemasonry in the Transvaal. Its centenary
                history, <em>Connaught Lodge No. 361 I.C. - One hundred years</em>, records
                that a formation meeting was held on 1 April 1903, when it was resolved
                that a lodge should be formed under the Irish Constitution and that a
                Charter and Working Warrant should be petitioned for.
            </p>

            <p>
                The Warrant attached to No. 361 had a long Irish history before reaching
                Pretoria. It had first been issued to Blue Lodge in Tanderagee, County
                Armagh, on 4 December 1760, and was later re-issued to lodges in
                Ballynahinch and Longford, Tasmania. The Grand Lodge of Ireland re-issued
                the Warrant to Connaught Lodge in Pretoria on 3 October 1903. The Lodge
                was then constituted and consecrated on 28 November 1903.
            </p>

            <p>
                The centenary volume places Connaught in the wider story of Irish
                Freemasonry in South Africa, alongside Abercorn, St Patrick, Ed H Croghan,
                Kendal Franks, Shamrock, Erin and other early Irish lodges. It also
                records the influence of Rt Wor Bro Sir Kendal Ferguson Franks and the
                work of founders and early members such as V Wor Bro Samuel Milbourne
                Tweddill.
            </p>

            <p>
                Today, the Lodge's archival work continues that centenary purpose:
                preserving warrants, minutes, photographs, correspondence and lodge
                records so that the history of Irish Freemasonry in South Africa remains
                accessible, verifiable and alive for future generations.
            </p>
        </div>
    );
}

export default HistoryOfConnaughtLodge;
